<span class="w-full isolate inline-flex rounded-md shadow-sm">
  <ng-content></ng-content>
</span>
